(function($){
	var dekal = function(){
		var self = this;


		var s = {
			customizer: $('#customizer'),
			wrapper: $('.text-wrapper'),
			text: $('#the-text'),
			getHeight: $('#get-height'),
			colorBox: $('.color-box'),
			fontFamily: $('.font-family'),
			heightSelect: $('select#height'),
			lengthSelect: $('select#length'),

			heightText: $('.height-selector input'),
			widthText: $('.width-selector input'),

			addToCart: $('#addToCart'),
			qty: $('#qty'),
			productId: $('#main-product-id').val(),
			thePrice: $('#thePrice'),
			correction: $('input#check-correction'),
			mirror: $('input#check-mirror'),
			editing: false,
			sizeResult : $('.size-result'),
			sizeSelector : $('.size-selector'),
			maxLength : $('input.max-size-width').val(),
			maxHeight : $('input.max-size-height').val(),
			
		};


		self.closestPriceStep = function( length ){
			var val = null;
			var diff  = 9999;
			var return_length = 0;
			
			$.each( s.priceLadder, function(k, v){
				var this_length = parseInt(v.length.replace('cm', '').trim());

				if (length > this_length) {
					if (typeof s.priceLadder[k+1] !== 'undefined') {
						var step = s.priceLadder[ k + 1 ];

						val = step.price;
						return_length = step.length;
					}
				}

				// var this_diff = Math.abs( length - this_length );
				// if( this_diff < diff ){
				// 	diff = this_diff;
				// 	val = v.price;
				// 	return_length = v.length;
				// }
			});
			
			return { length: return_length, price: val };	
			
		};

		self.init = function(){
			if (s.customizer.length < 1) { return; }
			s.priceLadder = JSON.parse( $('input.price-ladder').val() );

			self.actionHandler();
			setTimeout(function(){
				$(document).trigger('scroll');
			},2500);

			if (typeof QueryString === 'undefined') {

				s.customizer.find('section#step-1 a').first().trigger('click');
				s.customizer.find('section#step-2 a').first().trigger('click');

			} else{

				s.text.empty().html( QueryString.text );
				s.customizer.find('section#step-1 a').each( function(){
					var $this = $(this);

					if ( $this.html() == QueryString.font) { $this.trigger('click'); return; }
				});

				selected_color = QueryString.color.replace('+',' ');
				s.customizer.find('section#step-2 a').each( function(){
					var $this = $(this);

					if ($this.attr('data-color-name') == selected_color) { $this.trigger('click'); return; }
				});


				selected_length = QueryString.length.replace('+',' ');
				s.lengthSelect.find('option').each( function(){
					var $this = $(this);

					if ( $this.attr('data-length') == selected_length ) {
						s.lengthSelect.val($this.attr('value')).trigger('change');
					}
				});

				if( QueryString.correction == 'Ja' ) { s.correction.prop('checked', true); }


				s.editing = QueryString.cartID;
			}

		};


		self.actionHandler = function(){
			// s.lengthSelect.on('change', self.lengthChange );
			// s.heightSelect.on('change', self.heightChange );
			

			s.heightText.on('keyup', self.heightChange);
			s.widthText.on('keyup', self.lengthChange);

			s.colorBox.on('click', self.changeColor);
			s.fontFamily.on('click', self.changeFont);
			s.wrapper.on('click', function(){s.text.focus();});
			s.text.on('keyup',function(){ s.customizer.find('.master').trigger('keyup'); });
			s.addToCart.on( 'click', self.addToCart );
			s.qty.on('change', self.priceChange);
			$(document).on('scroll', self.scrolled);
			s.thePrice.on('change', self.allowPurchase );

			s.sizeSelector.on('click', self.showHideSizeSelector);


		};


		self.showHideSizeSelector = function(){
		
			var $this = $(this);
			var type = $this.attr('data-type');

			s.customizer.find('.selector').slideUp();
			s.customizer.find('.'+type+'-selector').slideDown();

		};


		self.scrolled = function(){
			if( $(document).width() > 799 ){
				
				setTimeout(function(){
					
					var headerHeight = $('.fusion-header-wrapper').outerHeight();
					s.wrapper.css('top', headerHeight + 'px');

				}, 100 );
			}
		};


		self.addToCart = function( e ){
			e.preventDefault();
			var $this = $(this);

			var _val = $this.html().replace(/(<([^>]+)>)/ig,"");

			$this.html( _val + ' <i class="fa fa-spin fa-circle-o-notch"></i>');

			var data = {
				nonce: gf_dt.nonce,
				action: 'gf-add-to-cart',
				qty: s.qty.val(),
				font: self.getActiveFontID(),
				color: self.getActiveColorName(),
				color_val: self.getActiveColorVal(),
				text: s.text.html(),
				length: s.dekalSize.width,
				height: s.dekalSize.height,
				correction: self.getCorrectionVal(),
				mirror: self.getMirrorVal(),
				product_id: s.productId,
				cartID: s.editing
			};
			
			$.ajax({
				url: gf_dt.ajax_url,
				type: 'POST',
				data: data,
				success:function( response ){
					if ( response.success ){
						window.location.href = response.data;
					}
				}
			});
		};


		self.changeFont = function( e ){
			e.preventDefault();

			var $this = $(this);
			var font = $this.attr('data-font');

			$this.closest('section').find('.active').removeClass('active');
			$this.addClass('active');

			s.text.css('font-family', font);
			s.customizer.find('.master').trigger('change');

		};


		self.changeColor = function( e ){
			e.preventDefault();

			var $this = $(this);
			var color = $this.attr('data-color');

			$this.closest('section').find('.active').removeClass('active');
			$this.addClass('active');

			s.text.css('color', color);
		};


		self.lengthChange = function(){
			var $this = $(this);
			
			var width = $this.val();
			var font_id = self.getActiveFontID(),
				text = s.text.html();


			
			s.customizer.find('.master').removeClass('.master');
			$this.addClass('master');
			
			if (!font_id) { return; }

			s.addToCart.attr('disabled', 'disabled').html('Laddar...');

			if (typeof s.currentAjax !== 'undefined') {
				s.currentAjax.abort();
			}
			s.currentAjax = $.ajax({
				url: gf_dt.ajax_url,
				type: 'POST',
				data: {
					action: 'calc-height',
					width: width,
					fontID: font_id,
					text: text
				},
				success:function( response ){
					self.setSizes( width, response.data, 'width' );
				}
			});

		};


		self.heightChange = function(){
			var $this = $(this);
			var height = $this.val();
			var font_id = self.getActiveFontID(),
				text = s.text.html();


			s.customizer.find('.master').removeClass('.master');
			$this.addClass('master');

			if (!font_id) { return; }

			s.addToCart.attr('disabled', 'disabled').html('Laddar...');

			if (typeof s.currentAjax !== 'undefined') {
				s.currentAjax.abort();
			}
			
			s.currentAjax = $.ajax({
				url: gf_dt.ajax_url,
				type: 'POST',
				data: {
					action: 'calc-width',
					height: height,
					fontID: font_id,
					text: text
				},
				success:function( response ){
					if( response.success ){
						self.setSizes( response.data, height, 'height');
					}	
				}
			});
		};


		self.setSizes = function( width, height, dominant ){
			var step = self.closestPriceStep( width );
			var html = '';
			

			switch( dominant ){
				case 'width':
					html = '<p>För längden ' + width + ' cm blir dekalen ca ' + height + ' cm hög.</p>';
					break;
				case 'height':
					html = '<p>För höjden ' + height + ' cm blir dekalen ca ' + width + ' cm lång.</p>';
					break;
			}


			if ( parseInt(width) > s.maxLength) {
				html+= '<p>Tyvärr blir detta för stort. Vi stödjer inte dekaler som är ' + width + ' cm långa.</p>' + gf_dt.error_msg;
				s.dekalSize = {
					width: 0,
					height: 0
				};
				s.hasErrors = true;
			} else if (parseInt(height) > s.maxHeight) {
				html+= '<p>Tyvärr blir detta för stort. Vi stödjer inte dekaler som är ' + height + ' cm höga.</p>' + gf_dt.error_msg;
				s.dekalSize = {
					width: 0,
					height: 0
				};
				s.hasErrors = true;
			} else if( height < 1 ){
				html+= '<p>Vi stödjer inte dekaler som är under 1 cm höga.</p>';
				s.hasErrors = true;
				s.dekalSize = {
					width: 0,
					height: 0
				};
			} else{
			

				s.dekalSize = {
					width: width,
					height: height
				};
				s.linePrice = step.price;
				s.hasErrors = false;
			}


			self.priceChange();
			s.sizeResult.empty().html( html );
		};


		self.priceChange = function(){
			var price = parseInt( s.linePrice );
			s.thePrice.empty().html( ( price * s.qty.val() ) + ' SEK' );	
			

			if( parseInt( s.thePrice.html().replace('SEK','').trim() ) && s.hasErrors === false ){
				s.addToCart.removeAttr('disabled').html('Lägg i varukorg');
			} else{
				s.addToCart.attr('disabled', 'disabled').html('Kan inte lägga i varukorg');
			}
			

			if (s.hasErrors) {
				s.thePrice.html('Denna dekal kan inte köpas.' + gf_dt.error_msg );
			}
		};



		self.getActiveFontID = function(){
			return $('section#step-1').find('.active').attr('data-font-id');
		};

		self.getActiveColorName = function(){
			return $('section#step-2').find('.active').attr('data-color-name');
		};
		self.getActiveColorVal = function(){
			return $('section#step-2').find('.active').attr('data-color');
		};

		self.getCorrectionVal = function() {
			return ($('#check-correction').is(":checked")) ? 'Ja' : 'Nej';
		};

		self.getMirrorVal = function() {
			return ($('#check-mirror').is(":checked")) ? 'Ja' : 'Nej';
		};


		self.init();
	};

	$(document).ready(function(){
		var dk = new dekal();
	});

	// $(document).on('blur', 'input, textarea', function () {
	//     setTimeout(function () {
	//         window.scrollTo(window.pageXOffset, window.pageYOffset-50);
	//     }, 0);
	// });


	var QueryString = function () {
	  // This function is anonymous, is executed immediately and
	  // the return value is assigned to QueryString!
	  var query_string = {};
	  var query = window.location.search.substring(1);
	  var vars = query.split("&");
	  for (var i=0;i<vars.length;i++) {
	    var pair = vars[i].split("=");

	        // If first entry with this name
	    if (typeof query_string[pair[0]] === "undefined") {
	      	query_string[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, ' '));
	        // If second entry with this name
	    } else if (typeof query_string[pair[0]] === "string") {
	      var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
	      query_string[pair[0]] = arr;
	        // If third or later entry with this name
	    } else {
	      query_string[pair[0]].push(decodeURIComponent(pair[1]));
	    }
	  }
	  return query_string;
	}();


})(jQuery, window);
